<template>
    <div class="t-feedback">
        <div class="t-container">
            <transition name="fadeRight">
                <success-cmp v-if="infoForm.success" class="_white" :props="{
                    title: $root.staticText.modal.successTitleReg,
                    text: $root.staticText.modal.successText,
                    btnEvent: $root.staticText.modal.successBtnEvent}">
                </success-cmp>
            </transition>
            <transition name="fadeRight">
                <error-cmp v-if="infoForm.error" class="_white" :props="{
                    title: $root.staticText.modal.errorTitleReg,
                    text: $root.staticText.modal.errorText}">
                </error-cmp>
            </transition>
            <transition name="fadeRight">
                <div v-if="!infoForm.success && !infoForm.error" class="t-feedback__container">
                    <div class="t-feedback__top">
                        <h2 class="t-feedback__title _vacancies">{{ title }}</h2>
                        <div v-if="subtext" class="t-feedback__text _vacancies">{{ subtext }}</div>
                        <a v-if="btnLink"
                           :href="btnLink"
                           target="_blank"
                           class="t-feedback__btn-left t-btn _border _big"
                        >
                            {{ btnLeft }}
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24ZM6.708 6.348V10.428C7.332 9.684 8.076 9.312 8.94 9.312C9.384 9.312 9.78 9.39599 10.14 9.56399C10.5 9.73199 10.764 9.948 10.944 10.212C11.124 10.476 11.244 10.764 11.316 11.088C11.388 11.4 11.412 11.892 11.412 12.564V16.932H9.48V12.996C9.48 12.216 9.444 11.724 9.372 11.508C9.3 11.292 9.168 11.136 8.988 11.004C8.808 10.884 8.568 10.812 8.292 10.812C7.968 10.812 7.68 10.896 7.44 11.052C7.188 11.208 6.996 11.448 6.888 11.772C6.768 12.096 6.708 12.564 6.708 13.188V16.92H4.776V6.348H6.708ZM14.316 6.348V10.428C14.94 9.684 15.684 9.312 16.548 9.312C16.992 9.312 17.388 9.39599 17.748 9.56399C18.108 9.73199 18.372 9.948 18.552 10.212C18.732 10.476 18.852 10.764 18.924 11.088C18.996 11.4 19.02 11.892 19.02 12.564V16.932H17.088V12.996C17.088 12.216 17.052 11.724 16.98 11.508C16.908 11.292 16.776 11.136 16.596 11.004C16.416 10.884 16.176 10.812 15.9 10.812C15.576 10.812 15.288 10.896 15.048 11.052C14.796 11.208 14.616 11.448 14.496 11.772C14.376 12.096 14.316 12.564 14.316 13.188V16.92H12.384V6.348H14.316Z" fill="white"/>
                            </svg>
                        </a>
                    </div>
                    <div class="t-feedback__bottom">
                        <form class="t-form _white" :class="{_disabled: infoForm.disabledForm}" @submit.stop.prevent="submitForm()">
                            <div class="t-feedback__content">
                                <div
                                    class="t-feedback__item"
                                    :class="[
                                        {_30: item.type === 'radio'},
                                        '_' + name,
                                        {_full: item.type === 'dropzone' || item.type === 'textLink'}
                                    ]"
                                    v-for="(item, name) in form"
                                >
                                    <div class="t-form__label">
                                        {{ item.label }}
                                        <span v-if="item.required">*</span>
                                    </div>

                                    <input
                                        v-if="item.type === 'text'"
                                        class="t-input"
                                        :class="{'_error': item.error, '_valid': item.valid}"
                                        :type="item.type"
                                        :placeholder="item.placeholder"
                                        v-model="item.value"
                                        @focus="focusForm(name)"
                                    >

                                    <masked-input
                                        v-if="item.type === 'phone'"
                                        class="t-input"
                                        :class="{'_error': item.error, '_valid': item.valid}"
                                        mask="\+\7(111)111-11-11"
                                        :placeholder="item.placeholder"
                                        v-model="item.value"
                                        :name="item.name"
                                        @input="focusForm(name)"
                                        :ref="name"
                                    />

                                    <vue-dropzone
                                        v-if="item.type === 'dropzone'"
                                        id="dropzone"
                                        ref="dropzone"
                                        class="_white"
                                        :class="{'_error': item.error, '_valid': item.valid}"
                                        :options="dropzoneOptions"
                                        :useCustomSlot="true"
                                    >
                                        <div class="dropzone-custom-title">{{ item.placeholder }}</div>
                                    </vue-dropzone>

                                    <!-- <input
                                        v-else-if="item.type === 'textLink' && (form[5].checked || form[6].checked)"
                                        class="t-input"
                                        :class="{'_error': item.error, '_valid': item.valid}"
                                        type="text"
                                        :placeholder="item.placeholder"
                                        v-model="item.value"
                                        @focus="focusForm(index)"
                                    > -->

                                    <svg class="t-form__error-svg" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L9 9" stroke="white" stroke-width="2"/>
                                        <path d="M9 1L1 9" stroke="white" stroke-width="2"/>
                                    </svg>
                                </div>
                            </div>

                            <div
                                v-if="!$route.fullPath.includes('/lk')"
                                class="t-personal-data"
                                :class="{_error: infoForm.errorPersonalData}"
                            >
                                <input
                                    @change="changePersonalDataFrom()"
                                    type="checkbox"
                                    id="personal-data-feedback-vac"
                                    class="t-personal-data__input"
                                />
                                <label for="personal-data-feedback-vac">
                                    <svg width="16" height="12" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z" fill="white"/>
                                    </svg>
                                    {{$root.staticText.forms.agree}}
                                    <a href="/user-agreement" target="_blank" class="t-personal-data__link">
                                        {{$root.staticText.forms.personalData}}
                                    </a>
                                </label>
                            </div>

                            <vue-recaptcha
                                ref="recaptcha"
                                size="invisible"
                                :sitekey="$root.sitekeyRecaptcha"
                                :load-recaptcha-script="true"
                                @verify="onCapchaRegister"
                                @expired="onCaptchaExpired"
                                @error="errorCaptcha"
                            />
                            <div class="t-feedback__raw">
                                <button
                                    class="t-btn _white _big t-feedback__btn"
                                >{{ button }}</button>
                            </div>

                        </form>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import success from '../modals/success';
    import error from '../modals/error';
    import vue2Dropzone from "vue2-dropzone";
    import Vue from "vue";
    import {mapGetters} from "vuex";
    import VueRecaptcha from "vue-recaptcha";

    export default {
        name: "form-vacancies",
        props: {
            title: String,
            vacancyId: String,
            subtext: String,
            btnLeft: String,
            btnLink: String,
            button: String,
        },
        data() {
            return {
                recaptchaToken: null,
                isValid: false,
                form: {
                    name: {
                        label: this.$root.staticText.forms.name,
                        name: 'name',
                        type: 'text',
                        value: '',
                        placeholder: this.$root.staticText.forms.placeholderName,
                        error: false,
                        valid: false,
                        required: true,
                        pattern: /[a-zа-яё]{2,}/
                    },
                    surname: {
                        label: this.$root.staticText.forms.surname,
                        name: 'surname',
                        type: 'text',
                        value: '',
                        placeholder: this.$root.staticText.forms.placeholderSurname,
                        error: false,
                        valid: false,
                        required: true,
                        pattern: /[a-zа-яё]{2,}/i
                    },
                    email: {
                        label: this.$root.staticText.forms.email,
                        name: 'email',
                        type: 'text',
                        value: '',
                        placeholder: this.$root.staticText.forms.placeholderEmail,
                        error: false,
                        valid: false,
                        required: true,
                        pattern: /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/i
                    },
                    phone: {
                        label: this.$root.staticText.forms.phone,
                        name: 'phone',
                        type: 'phone',
                        value: '',
                        placeholder: '+7',
                        error: false,
                        valid: false,
                        required: true,
                        pattern: /^\+\d{1,3}\s?\(\d{3}\)\s?\d{3}(-\d{2}){2}$/
                    },
                    files: {
                        label: '',
                        name: 'files[]',
                        type: 'dropzone',
                        value: '',
                        placeholder: this.$root.staticText.forms.placeholderDropzone,
                        error: false,
                        valid: false,
                        required: false,
                        pattern: ''
                    }
                },
                dropzoneOptions: {
                    url: 'callbackBecomeVendor',
                    autoQueue: false,
                    thumbnailWidth: 80,
                    thumbnailHeight: 80,
                    maxFiles: 12, // максимальное количество файлов
                    maxFilesize: 10, // максимальный вес одного файла, MB
                    addRemoveLinks: true,
                    dictRemoveFile: "×",
                    acceptedFiles: '.jpg,.jpeg,.png,.docx,.doc,.pdf,.txt,.tif,.svg',
                    dictFileTooBig: 'Файл слишком большой. Максимальный размер файла: {{maxFilesize}} MB.',
                    dictInvalidFileType: "Вы не можете загружать файлы этого типа.",
                    dictMaxFilesExceeded: "Вы не можете больше загружать файлы.",
                },
                infoForm: {
                    action: 'feedbackVacancies',
                    disabledForm: false,
                    isPersonalData: false,
                    errorPersonalData: false,
                    success: false,
                    error: false,
                },
            }
        },
        computed: {
            ...mapGetters('lk', ['isAuth']),
        },
        components: {
            vueDropzone: vue2Dropzone,
            'success-cmp': success,
            'error-cmp': error,
            VueRecaptcha,
        },
        methods: {

            onCapchaRegister(recaptchaToken) {
                this.recaptchaToken = recaptchaToken;
                if (this.isValid) {
                    this.sendForm();
                }
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset();
            },
            errorCaptcha() {
                console.log('errorCaptcha');
            },
            validate() {
                let is_valid = true;

                // проверка галочки
                if (!this.$route.fullPath.includes('/lk') && !this.infoForm.isPersonalData) {
                    this.infoForm.errorPersonalData = true;
                    is_valid = false;
                }

                for (const name in this.form) {
                    const field = this.form[name];
                    field.error = false;
                    field.valid = true;

                    // проверяем наличие файлов 
                    if (name === 'files') {
                        const isFilesExists = this.$refs.dropzone[0].getAcceptedFiles().length
                        if (isFilesExists) continue;

                        this.form[name].error = true;
                        is_valid = false;
                    } else {
                    // проверяем на соответсвие паттерну
                        const isPatternCheckSuccess = field.pattern.test(
                            field.value.trimEnd()
                        )
                    
                        if (isPatternCheckSuccess) continue;

                        field.error = true;
                        field.valid = false;
                        is_valid = false
                    }
                }

                this.isValid = is_valid;
            },
            submitForm() {
                this.validate();

                if (this.isValid) {
                    this.$refs.recaptcha.execute();
                }
            },
            sendForm() {
                this.infoForm.disabledForm = true;
                let formData = new FormData();
                formData.append('recaptchaToken', this.recaptchaToken);

                for (const name in this.form) {
                    const field = this.form[name];
                    if (name === 'files') continue;

                    formData.append(
                        field.name,
                        field.value.toString().trimEnd()
                    );
                }

                // добавляем vacancyId
                formData.append('vacancyId', this.vacancyId);

                const acceptedFiles = this.$refs.dropzone[0].getAcceptedFiles();

                acceptedFiles.forEach(file => {
                    formData.append(this.form.files.name, file)
                })

                Vue.http.post(this.infoForm.action, formData)
                    .then(response => response.json())
                    .then(data => {
                        this.infoForm.disabledForm = false;
                        if (data.success) {
                            this.infoForm.success = true;
                            setTimeout(() => {
                                this.clearFrom();
                            }, 5000)
                        } else {
                            this.infoForm.error = true;
                            setTimeout(() => {
                                this.clearFrom();
                            }, 5000)
                        }
                    })
                    .catch(error => {
                        console.error(error.message)
                        this.infoForm.disabledForm = false;
                        this.infoForm.error = true;
                        setTimeout(() => {
                            this.clearFrom();
                        }, 5000)
                    });
            },
            changePersonalDataFrom() {
                this.infoForm.isPersonalData = !this.infoForm.isPersonalData;
                this.infoForm.errorPersonalData = !this.infoForm.isPersonalData;
            },
            focusForm(name) {
                this.form[name].error = false;
            },
            clearFrom() {
                this.infoForm.success = false;
                this.infoForm.error = false;

                for (const name in this.form) {
                    this.form[name].error = false;
                    this.form[name].valid = false;
                    
                    if (name === 'files') {
                        this.$refs.dropzone[0]?.removeAllFiles()
                    } else {
                        this.form[name].value = '';
                    }
                }
                this.infoForm.isPersonalData = false;
                this.infoForm.errorPersonalData = false;
                document.querySelector('#personal-data-feedback-vac').checked = false;
            }
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/forms/form-vacancies.vue